<template>
  <Drawer
    v-model:visible="visible"
    :header="header"
    :modal="true"
    closable
    :position="'bottom'"
    :style="{ width: '100vw', height: 'auto' }"
  >
    <div class="overflow-auto h-[50vh]">
      <Timeline :value="screenTimeEventsSorted" class="mt-4">
        <template #content="{ item }">
          <div class="flex flex-row gap-2" v-if="item.impact >= 0">
            <div class="flex items justify-between w-full text-sm text-gray-700">
              <div class="flex flex-col text-green-700 font-semibold">
                <span class="text-ellipsis overflow-hidden whitespace-nowrap max-w-30">{{
                  item.description
                }}</span>
                <div class="flex items-center gap-2">
                  <span class="text-sm text-gray-500 align-middle">+{{ item.impact }} mins</span>
                </div>
                <div class="flex flex-row items-end text-gray-400 gap-1">
                  <span>{{ DateTime.fromISO(item.timestamp).toFormat('ccc d LLL') }}</span>
                  <span>{{ DateTime.fromISO(item.timestamp).toFormat('HH:mm') }}</span>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template #opposite="{ item }">
          <div class="flex flex-col gap-2" v-if="item.impact < 0">
            <div class="flex items justify-between w-full text-sm text-gray-700">
              <div class="flex flex-col text-red-700 font-semibold">
                <span class="text-ellipsis overflow-hidden whitespace-nowrap max-w-30">{{
                  item.description
                }}</span>
                <div class="flex items start gap-2">
                  <span class="text-sm text-gray-500">{{ item.impact }} mins</span>
                </div>
                <div class="flex flex-row items-end text-gray-400 gap-1">
                  <span>{{ DateTime.fromISO(item.timestamp).toFormat('ccc d LLL') }}</span>
                  <span>{{ DateTime.fromISO(item.timestamp).toFormat('HH:mm') }}</span>
                </div>
              </div>
            </div>
          </div>
        </template>
      </Timeline>
    </div>
  </Drawer>
</template>
<script setup lang="ts">
  import Drawer from 'primevue/drawer'
  import Child from '../store/models/Child'
  import { computed } from 'vue'
  import Chip from 'primevue/chip'
  import Timeline from 'primevue/timeline'
  import { DateTime } from 'luxon'

  const visible = defineModel<boolean>('visible')

  const props = defineProps<{
    child: Child | null
  }>()

  const header = computed(() => {
    return `${props.child?.name}'s History`
  })

  const screenTimeEventsSorted = computed(() => {
    if (!props.child || !props.child.screenTimeEvents) {
      return []
    }
    const screenTimeEvents = props.child.screenTimeEvents
    return screenTimeEvents.sort((a, b) => {
      if (!a.timestamp || !b.timestamp) {
        return 0
      }
      return new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime()
    })
  })
</script>
